import React from 'react'

export default function CalculatedRatingBand ({ label = 'Calculated Rating', items = [] }) {
  return (
    <div className='tti-calculated-rating-band'>
      <div className='tti-calculated-rating-heading'>{label}</div>
      <div className='tti-calculated-rating-panels'>
        {items.map(item => (
          <div className='tti-calculated-rating-panel' key={item.label || label}>
            {item.label && <div className='tti-calculated-rating-caption'>{item.label}</div>}
            <div className='tti-calculated-rating-value'>{item.value || '--'}</div>
            {item.detail && <div className='tti-calculated-rating-detail'>{item.detail}</div>}
          </div>
        ))}
      </div>
    </div>
  )
}
